import type { LearnFAQ } from "@/pages/learn/learnShared";
import {
  makeEsArticle,
  esSaintRelated,
  type EsArticleInput,
} from "./learnFactoryEs";

const reviewBlock = {
  writtenBy: "Neuro Wellness TMS Centers of America",
  reviewedBy: "Daniel Pietras, MD",
  published: "November 3, 2026",
  lastReviewed: "November 3, 2026",
  lastUpdated: "November 3, 2026",
};

const faqs: LearnFAQ[] = [
  {
    question: "¿Quién califica para SAINT®?",
    answer:
      "SAINT® está autorizada por la FDA para adultos con trastorno depresivo mayor que no han mejorado con antidepresivos. La elegibilidad se confirma mediante una evaluación psiquiátrica que revisa el historial de medicación y las contraindicaciones.",
  },
];

export const esWhoQualifies = makeEsArticle({
  slug: "who-qualifies-for-saint-tms",
  title: "¿Es SAINT® TMS adecuado para mí? Criterios de elegibilidad",
  description:
    "Descubra si SAINT® TMS es adecuado para usted: autorizada por la FDA para adultos con trastorno depresivo mayor que no han mejorado con antidepresivos.",
  h1: "¿Es SAINT® TMS adecuado para mí?",
  breadcrumbLabel: "¿Es SAINT® adecuado para mí?",
  shortAnswer:
    "SAINT® está autorizada por la FDA (510(k) K220177, septiembre de 2022) para adultos con trastorno depresivo mayor que no han logrado una mejoría satisfactoria con antidepresivos en el episodio actual. La elegibilidad se confirma mediante una evaluación psiquiátrica que incluye el historial de medicación, el cribado de contraindicaciones y la confirmación de que la fMRI puede realizarse de forma segura. SAINT® no está indicada para ansiedad, trastorno bipolar, TEPT u otras condiciones.",
  keyTakeaways: [
    "SAINT® es para adultos con trastorno depresivo mayor.",
    "Está indicada cuando los antidepresivos no han mejorado lo suficiente.",
    "La elegibilidad se confirma mediante una evaluación psiquiátrica.",
    "No está indicada para ansiedad, trastorno bipolar, TEPT u otras condiciones.",
    "SAINT® está autorizada por la FDA (510(k) K220177, septiembre de 2022).",
  ],
  sections: [
    {
      heading: "Criterios de elegibilidad",
      paragraphs: [
        "SAINT® está indicada para adultos con trastorno depresivo mayor cuyos síntomas no han mejorado lo suficiente con antidepresivos. La elegibilidad la determina un profesional sanitario cualificado mediante una evaluación psiquiátrica.",
        "La evaluación revisa el historial de medicación, criba contraindicaciones y confirma que la fMRI puede realizarse de forma segura. SAINT® no está indicada para ansiedad, trastorno bipolar, TEPT u otras condiciones.",
      ],
    },
  ],
  faqs,
  sources: [
    {
      citation:
        "U.S. Food and Drug Administration. 510(k) Premarket Notification — Magnus Neuromodulation System with SAINT Technology (K220177, September 2022).",
      url: "https://www.accessdata.fda.gov/scripts/cdrh/cfdocs/cfpmn/pmn.cfm",
    },
  ],
  relatedLinks: esSaintRelated,
  reviewBlock,
} satisfies EsArticleInput);
